import script from "./HrCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./HrCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./HrCheckbox.vue?vue&type=style&index=0&id=6eba721c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eba721c"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
